// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCPZPL6zASMFLnXKwaJyRR-fB-lqpECLyg",
  authDomain: "suzukicashout.firebaseapp.com",
  projectId: "suzukicashout",
  storageBucket: "suzukicashout.firebasestorage.app",
  messagingSenderId: "947933985509",
  appId: "1:947933985509:web:caf71ed0d2f3e5541a720c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
